import Store from '../../store'
import { errorHandler, successHandler } from '../helpers/handler'
import adminHttp from './http'

const axios = adminHttp
const URL = `crypto-wallets`

export default {
  data() {
    return {
      getWallet: async ({ ...params }) => {
        const endpoint = `${URL}/admin`
        try {
          const res = await axios.get(endpoint, {
            params: Object.fromEntries(
              Object.entries(params).filter(([_, value]) => value !== '')
            ),
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getWalletHistory: async ({ ...params }) => {
        const endpoint = `${URL}/admin/wallet-histories`
        try {
          const res = await axios.get(endpoint, {
            params: Object.fromEntries(
              Object.entries(params).filter(([_, value]) => value !== '')
            ),
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      }
    }
  }
}
